import {Injectable} from '@angular/core';
import {
    IGetPropertyResponse,
    IPropertyDate,
    IPropertyIntroduction
} from "libraries/service/resources/hotel/ISearchResponse";
import {IBookingPropertyDescription} from "../booking/interfaces/IGetBookings";

@Injectable({
    providedIn: 'root'
})
@Injectable()
export class HotelPropertyMappingService {

    /**
     * Map New Hotel Property Format to old Fomat, in proder to fit to existing Components
     * @param newMapping
     */
    public mapNewToOld(newMapping: any): IGetPropertyResponse {
        if (!newMapping.property.syscodeArray) {
            return newMapping;
        }
        
        return {
            property: {
                date: newMapping.property?.date,
                room: newMapping.property?.room,
                brand: newMapping.property?.brand,
                key: newMapping.property?.key,
                message: newMapping.property?.message,
                floor: newMapping.property?.floor,
                media: newMapping.property?.property?.introduction?.media,
                state: newMapping.property?.property?.address,
                languageCode: newMapping.property?.property?.descriptionArray?.length ?
                    newMapping.property?.property?.descriptionArray[0].languageCode : null,
                nature: newMapping.property?.property?.xIs,
                airport: newMapping.property?.airportArray?.length ? newMapping.property?.airportArray[0] : null,
                content: newMapping.property?.content,
                customer: newMapping.property?.customer,
                distance: newMapping.property?.distanceArray?.length ? newMapping.property?.distanceArray[0] : null,
                language: newMapping.property?.language,
                template: newMapping.property?.template,
                description: newMapping.property?.property?.introduction?.description,
                introduction: this.transformIntroduction(newMapping.property?.property?.introduction),
                formOfPayment: newMapping.property?.formOfPaymentArray?.length ?
                    newMapping.property?.formOfPaymentArray[0] : null,
                credit: newMapping.property?.credit,
                alternatives: newMapping.property?.property?.alternativeArray,
                descriptions: this.mapDescriptions(newMapping.property?.property?.descriptionArray),
                host: newMapping.property?.property?.host,
                hostCode: newMapping.property?.property?.host?.code,
                hostShortcut: newMapping.property?.property?.host?.shortcut,
                sourceCode: newMapping.property?.property?.source?.code,
                sourceShortcut: newMapping.property?.property?.source?.shortcut,
                mealplans: newMapping.property?.mealplansArray,
                medias: newMapping.property?.property?.mediaArray,
                targetLanguageCode: newMapping.property?.property?.targetLanguageCode,
                code: newMapping.property?.property?.code,
                keywords: newMapping.property?.property?.keywordArray,
                keywordXCodes: newMapping.property?.property?.keywordArray?.length ?
                    newMapping.property?.property?.keywordArray[0].xCode : null,
                name: newMapping.property?.property?.name?.value,
                status: newMapping.property?.status,
                address: newMapping.property?.property?.address,
                airportClosest: newMapping.property?.airportClosest,
                city: newMapping.property?.property?.city?.nameArray?.length ?
                    newMapping.property?.property?.city?.nameArray[0].value : null,
                country: newMapping.property?.property?.country.iso,
                dateLastCancellationWithoutPenalty: newMapping.property?.quote?.dateLastCancellationWithoutPenalty,
                geoposition: newMapping.property?.property?.geoposition,
                id: newMapping.property?.property?.id,
                keyword: newMapping.property?.property?.keywordArray?.length ?
                    newMapping.property?.property?.keywordArray[0] : null,
                mealplan: newMapping.property?.quote?.mealplan,
                property: newMapping.property?.property?.alternativeArray?.length ?
                    newMapping.property?.property?.alternativeArray[0].propertyName : null,
                rank: newMapping.property?.property?.geoposition?.xRank,
                rating: newMapping.property?.property?.rating,
                sites: newMapping.property?.siteArray,
                syscode: newMapping.property?.property?.syscodeArray?.length ?
                    newMapping.property?.property?.syscodeArray[0].value : null,
                telephones: newMapping.property?.telephoneArray,
                total: newMapping.property?.quote?.total,
                xId: newMapping.property?.property?.xId,
                zipcode: newMapping.property?.property?.address?.zipCode
            }
        }
    }

    private mapDescriptions(newDescriptions: any): IBookingPropertyDescription[] {
        return newDescriptions
            .map((description: any): IBookingPropertyDescription => {
                return {
                    ...description,
                    textLines: description.textLineArray
                }
            })
    }

    private transformIntroduction(newIntroduction: any): IPropertyIntroduction {
        return {
            ...newIntroduction.description,
            textLines: newIntroduction.description.textLineArray,
            types: [newIntroduction.description.type]
        }
    }
}
